// API Models

import { mapName, Name } from './common.model';

export interface ApiPatientResponse {
  patientId: number;
  firstName: string;
  lastName: string;
  verifiedHipaa: boolean;
  acceptedTermsAndConditions: boolean;
  consentedToMarketing: boolean;
  refusedGenericMedications: boolean;
  reorder: boolean;
  isPharmacyPatient: boolean;
}

export type ApiGetPatientsResponse = ApiPatientResponse[];

export interface ApiPatientRequest {
  acceptedTermsAndConditions?: boolean;
  consentedToMarketing?: boolean;
  refusedGenericMedications?: boolean;
  reorder?: boolean;
  isPharmacyPatient?: boolean;
  verifiedHipaa?: boolean;
}

// Front End Models

export interface Patient extends Name {
  id: number;
  verifiedHipaa: any;
  acceptedTermsAndConditions: boolean;
  consentedToMarketing: boolean;
  refusedGenericMedications: boolean;
  reorder: boolean;
  isPharmacyPatient: boolean;
}

export interface UpdatePatientForm extends ApiPatientRequest {}

// Mappers

export const mapPatient = (p: ApiPatientResponse): Patient => {
  return {
    ...p,
    id: p.patientId,
    ...mapName(p.firstName, p.lastName),
    reorder: p.reorder,
    isPharmacyPatient: p.isPharmacyPatient,
  };
};
